export function adjustFontSizeToViewport(
  viewportSize: number,
  text: string,
  fontFamily: string,
): number {
  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  ctx.font = `1px ${fontFamily}`;

  return Math.round(viewportSize / ctx.measureText(text).width);
}
